var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$route.query.edit)?_vm._t("header",null,{"headerInfo":"Documents Upload & Request"}):_vm._e(),_c(_vm.component,{tag:"component"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }